import { mapProps } from 'utils/recompose';
import EllipsisText from '@shopline/dashboard-ui/dist/esm/components/ellipsisText';
import Text from '../Text';

export default mapProps(({ children, ...props }) => ({
  ...props,
  as: EllipsisText,
  text: children,
}))(Text);
